export default __webpack_public_path__ + "638499f1d25146f785777a5d67b22560.wav";